/**
 * Pads a given number with a leading 0 if less than 10.
 */

const padWithZero = (int: string|number): string => {
    int = typeof int === 'string' ? parseInt(int) : int;

    return int < 10 ? '0' + int.toString() : int.toString();
};

export default padWithZero;